module.exports = __webpack_public_path__ + "img/2.bdf2b86d.png";